/**
 * Takes an object and returns a URL query string of its key/value pairs.
 * @param {Object} obj
 * @return {String}
 */

function serializeObject(params) {
  return Object.entries(params)
    .map(([key, value]) => {
      const v = typeof value === 'object' ? JSON.stringify(value) : value;

      return `${encodeURIComponent(key)}=${encodeURIComponent(v)}`;
    })
    .join('&');
}

export default serializeObject;
